import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Waves, Loader2, LogIn } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/65plynsu_DJI_20260612182230_0011_D.jpg";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(email.trim(), password); }
    catch (e2) { setErr(e2?.response?.data?.detail || "Could not sign in"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-sand-100 px-5">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src={LOGO} alt="TRIBE" className="h-16 w-16 rounded-full object-cover shadow ring-2 ring-white" />
          <h1 className="mt-4 font-display text-3xl tracking-wide text-slate-900">TRIBE <span className="text-brand-700">Beach</span></h1>
          <p className="mt-1 flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-[0.24em] text-slate-500">
            <Waves size={13} className="text-sea" /> Staff sign in
          </p>
        </div>
        <form onSubmit={submit} className="space-y-3 rounded-2xl border border-sand-300 bg-white p-6 shadow-sm" data-testid="login-form">
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus
              className="h-11 w-full rounded-lg border border-sand-300 bg-sand-50 px-3 text-sm outline-none focus:border-brand" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Password</label>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="h-11 w-full rounded-lg border border-sand-300 bg-sand-50 px-3 text-sm outline-none focus:border-brand" />
          </div>
          {err && <p data-testid="login-error" className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive">{err}</p>}
          <button data-testid="login-submit" type="submit" disabled={busy}
            className="flex h-11 w-full items-center justify-center gap-2 rounded-full bg-brand text-base font-semibold text-white transition-colors hover:bg-brand-600 disabled:opacity-60">
            {busy ? <Loader2 className="animate-spin" size={18} /> : <LogIn size={18} />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
